import {Component, EventEmitter, inject, OnInit, Output, ViewChild} from '@angular/core';
import { IGX_DIALOG_DIRECTIVES, IgxDialogComponent } from '@infragistics/igniteui-angular/dialog';
import { IgxLinearProgressBarComponent, IgxProgressBarModule } from '@infragistics/igniteui-angular/progressbar';
import { OverlaySettings } from '@infragistics/igniteui-angular/core';
import {
  IGX_CARD_DIRECTIVES,
} from '@infragistics/igniteui-angular/card';
import { IgxLayoutModule } from '@infragistics/igniteui-angular/directives';
import {TranslateModule} from '@ngx-translate/core';
import {GenericoService} from "../../../../core/services/generico.service";
import {ClsObjGenerico} from "../../../../clases-pu/util/cls-obj-generico";

@Component({
  selector: 'app-wait-dialog-custom',
  templateUrl: './wait-dialog-custom.component.html',
  styleUrls: ['./wait-dialog-custom.component.scss'],
  imports: [
    IGX_DIALOG_DIRECTIVES,
    IGX_CARD_DIRECTIVES,
    IgxLayoutModule,
    TranslateModule,
    IgxDialogComponent,
    IgxProgressBarModule,
  ]
})
export class WaitDialogCustomComponent implements OnInit {
  private servicioGen = inject(GenericoService);

  @ViewChild('waitDialog', {read: IgxDialogComponent, static: true})
  public waitDialog: IgxDialogComponent;
  @ViewChild('barraProgreso', {read: IgxLinearProgressBarComponent, static: true})
  public barraProgreso: IgxLinearProgressBarComponent;
  @Output() evtCerrado = new EventEmitter<void>();

  public waitTitulo: string;
  public waitIcon: string;
  public MENSAJE: string;
  public MENSAJE2: string;
  public MENSAJE3: string;

  private msgRenintento: string;
  private mObjGenerico = new ClsObjGenerico();

  constructor() {
  }

  ngOnInit(): void {
    this.msgRenintento = this.mObjGenerico.getTranslationsMensajes('MENSAJES.GRALS.REINTENTANDO');
    this.servicioGen.reintentos$.subscribe(reintento => {
      this.MENSAJE3 = `${this.msgRenintento} (${reintento}/${this.servicioGen.maxR})`;
    });
  }

  public abrir(mensaje: string, titulo: string, icono: string, overlaySettings: OverlaySettings) {
    this.waitTitulo = titulo;
    this.waitIcon = icono;
    this.MENSAJE = mensaje;
    this.waitDialog.open(overlaySettings);
  }

  public cerrar() {
    this.waitDialog.close();
    this.evtCerrado.emit();
  }
}
